export default {
    methods: {
        getDatiClienteInit() {
            return {
                userId: -1,
                companyCode: "",
                userName: "",//uguale a RagioneSociale --> serve per login
                ragioneSociale: "",
                indirizzo: "",
                eMail: "",
                pIva: "",
                telefono: "",
                certificazione: "",
                certificazioneFSCS: false,
                certificazioneFSCG: false,
                certificazionePEFC: false,
                certificazionePEFCG: false,
                certificazioneFPC: false,
                certificazioneISO: false,
                codiceCertificazione: "",
                codiceFSCS: "",
                codiceFSCG: "",
                codicePEFC: "",
                codiceFPC: "",
                codiceISO: "",
                dataAuditFSCS: "",
                dataAuditFSCG: "",
                dataAuditFPC: "",
                dataAuditPEFC: "",
                dataAuditPEFCG: "",
                dataAuditISO: "",
                gruppo: "",
                applicazione: "",
                respCoc: "",
                respFPC: "",
                terzisti: false,
                rischio: false,
                tipologia: "",
                dataIngresso: "",
                dataRimozione: "",
                preventivoFSCS: "",
                preventivoFSCG: "",
                preventivoPEFC: "",
                preventivoFPC: "",
                preventivoISO: "",
                mantenimentoFSCS: "",
                mantenimentoFSCG: "",
                mantenimentoPEFC: "",
                mantenimentoFPC: "",
                mantenimentoISO: "",
                attivita: "",
                produttoreTrader: "",
                enabled: true,
                passwordHash: "",
                modificato: false,
            }
        }
    }
}